import React, { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import OrganizationSettingsRoomsDirectionsIndexPage from "./pages/Index";

const OrganizationSettingsRoomsDirectionsPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className={"content"}>
			<Switch>
				<Route exact path={`${props.match.url}/`} component={OrganizationSettingsRoomsDirectionsIndexPage} />
			</Switch>
		</div>
	);
};
export default OrganizationSettingsRoomsDirectionsPage;
